import type { Infer } from "superstruct";
import type { Immutable } from "@/types/immutable";
import type { matchPredictionResponseStruct } from "./matchPredictionResponse.structs";
import type { TrackingEvent as XpaTrackingEvent } from "@motain/xpa-proto-files-web/lib/types/tracking";
import type { NativeShare } from "@motain/xpa-proto-files-web/lib/types/native_share";
import type { ButtonComponent } from "@motain/xpa-proto-files-web/lib/types/basic";

export enum MatchPredictionVariant {
  Home = 0,
  Draw = 1,
  Away = 2,
}
export interface PredictionButton
  extends Immutable<{
    name?: string;
    color?: string;
    darkModeColor?: string;
    predictions: number;
    percentPoints: number;
    trackingEvents: Array<XpaTrackingEvent> | undefined;
  }> {}

export interface MatchPredictionState {
  title: string;
  subtitle: string;
  share?: NativeShare;
  totalPredictions: number;
  home: PredictionButton;
  draw: PredictionButton;
  away: PredictionButton;
  shareButton?: ButtonComponent;
  shareText?: string;
  trackEvents: Array<XpaTrackingEvent>;
  totalOfVotes: number;
  persistedUserPrediction: MatchPredictionVariant | undefined;
}

export type MatchPredictionResponse = Infer<
  typeof matchPredictionResponseStruct
>;
